import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { EXECUTION_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  children?: () => ReactNode
}

const PingExecutionService = ({
  children
}: Props) => {
  const url = `${EXECUTION_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      method='get'
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default PingExecutionService
